<template>
  
  <ModalContainer queryParam="f018" ref="modalContainer" size="lg">


    <b-alert 
      v-if="messageAlert && !isLoading" 
      show 
      :variant="messageAlert.variant"
      class="p-2 text-center"
    >
      {{ messageAlert.text }}
    </b-alert>

    <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>

    <b-card class="mb-0" v-if="!isLoading">

      <h3 class="text-center mb-1">Cargar Formulario 018</h3>

      

      <hr class="mb-3"/>

      <LoadFileInput
        v-model="newFile018"
        :urlFile="urlFile018"
        label="Formulario 018A - Transanastesico"
        class="mb-3"
      />

      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="onSaveFile">
          Guardar
        </b-button>
      </div>

    </b-card>

    <GeneralLoader v-if="isLoading" class="p-3"/>

    
  </ModalContainer>  
</template>

<script>

import { ModalContainer, LoadFileInput, GeneralLoader } from "@/shared/components";
import { fileService } from "@/shared/services";
import { procedimientosFormulariosService } from "../../services";
import { getDataForms } from "../../helpers/getDataForms";


export default {

  name: "Formulario018",

  components: {
    ModalContainer,
    LoadFileInput,
    GeneralLoader
  },


  created() {
    this.loadData();
  },

  props:{
    dataProceso:{
      default:null,
      required:false
    }
  },

  data() {
    return {

      isLoading: false,

      newFile018: null,
      urlFile018: null,

      tokenProceso: null,
      
      idRegistroForm: null,

      messageAlert: null,
      codigoFormulario: '018',
      tokenFormulario: null,

    };
  },


  methods: {

    async loadData(){

      this.isLoading = true

      this.clearDataForm();

      this.tokenProceso = this.$route.query.forms;

      this.tokenFormulario = this.$route.query.f018;

      const response = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario)
      
      if(!response || !response.dataJson) {
        this.isLoading = false
        
        return;}

      let dataFormulario = JSON.parse(response.dataJson)
      
      if(!dataFormulario) return;
      
      this.messageAlert = {
          text: 'Info registrada',
          variant: 'success'
        };

      let paciente = `${response.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${response.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

      

      if(dataFormulario && dataFormulario.urlFile)       
        this.urlFile018 = dataFormulario.urlFile;

      this.isLoading = false
    },


    async onSaveFile() {

      const result = await this.$swal({
        title: "Guardar Archivo",
        text: "¿Esta seguro de guardar el archivo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Guardar!",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) return;


      const uploadFile = await fileService.upload(
        'procesos_formularios',
        this.newFile018,
        'f018',
        this.urlFile018
      );

      const dataForm = {
        urlFile: uploadFile
      }


      // validacion de eliminacion
      if(this.newFile018 === undefined)
        await fileService.deleteFile(this.urlFile018);

      const params = {
        nameForm       : this.codigoFormulario,
        dataJson       : JSON.stringify(dataForm),
        tokenProceso   : this.tokenProceso,
        idRegistroForm : this.idRegistroForm,
        tokenFormulario: this.tokenFormulario
      };

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if(!responseSave){
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

      this.$emit("formulario-guardado");

await this.$router.push({
        query: {
          ...this.$route.query,
          f018: undefined
        }
      });


      

      // await this.$router.push({ query: { ...this.$route.query, finf: undefined } });
      this.$emit("formulario-guardado");


     
    },


    clearDataForm() {
      this.newFile018 = null;
      this.urlFile018 = null;
    }
  },

  watch: {

    '$route.query.f018': {
      immediate: true,
      handler() {
        this.loadData();
      }
    }
  }
}
</script>
